export const LIST_SP_TAB_SUMMARY = 'list_sp_summary_tab';
export const LIST_SP_TAB_HISTORY = 'list_sp_history_tab';
export const LIST_SP_TAB_PROGRESS = 'list_sp_progress_tab';
